import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Trans, useTranslation } from 'react-i18next';
import Checkbox from '@mui/material/Checkbox';
import { changePage, removeSavedJobOnSavedTab, fetchSavedJobs } from '../../../actions/jobs';
import classes from './scss/savedJobs.module.scss';
import PaginationPanel from '../../common/PaginationPanel/PaginationPanel';
import RecommendedJobsList from '../../common/ListsOfComponents/RecommendedJobsList';
import TableSkeleton from '../../common/Skeletons/TableSkeleton';
import JobCardSkeleton from '../../common/Skeletons/JobCardSkeleton';
import { maxMobileSize, savedJobOptions } from '../../../utils/constants';
import { useWindowSize } from '../../../utils/hooks';
import AppliedJobCard from '../../common/Cards/AppliedJobCard/AppliedJobCard';
import { Menu } from '../../common/Form/Menu/Menu';
import { actionTypes } from './types';
import Table from '../../common/Table/Table';
import { savedJobsConstant } from './constants/savedJobs';

function SavedJobs(props) {
  const { jobsData, counter, recommendedJobs, searchParams, currentPage, setCurrentPage } = props;

  const pendingFetch = useSelector((state) => state.jobs.pendingFlag);
  const [showThreeDotMenu, setShowThreeDotMenu] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const pagination = useSelector((state) => state.jobs.pagination);
  const size = useWindowSize();

  const setActivePage = (page) => dispatch(changePage(page));

  const handleJobOptions = (action, jobId) => {
    switch (action) {
      case actionTypes.VIEW:
        return navigate(`/dashboard/jobs/${jobId}`);
      case actionTypes.UNSAVE:
        dispatch(removeSavedJobOnSavedTab({ JobId: jobId }));
        dispatch(fetchSavedJobs({ PageNumber: 1, PageSize: 10 }, searchParams));
        return true;
      case actionTypes.APPLY:
        localStorage.setItem(`OpenedJobId`, JSON.stringify(jobId));
        return navigate({
          pathname: '/dashboard/jobs',
          search: '?tab=saved&action=apply'
        });
      default:
        return null;
    }
  };

  return (
    <>
      <div className="row pt-5">
        <div className={`d-flex align-items-center flex-wrap ${classes.titleContainer}`}>
          <h1 className="d-inline align-middle text-nowrap">{t('profile.tabs.savedjobs')}</h1>
          {Array.isArray(jobsData) && (
            <Trans i18nKey="dashboard.jobs.foundjobs" counter={counter}>
              <span className="align-middle px-5">
                Found {{ counter }} job{counter > 1 ? 's' : ''}
              </span>
            </Trans>
          )}
        </div>
      </div>
      <div className="row w-100">
        <div className="col-md-12 pt-4 mb-5" style={{ gap: '19px' }}>
          {size.width > maxMobileSize ? (
            <Table cols={savedJobsConstant(t, handleJobOptions)} data={jobsData} pendingFetch={pendingFetch} />
          ) : (
            <div data-testid="mobile" className="d-flex flex-column gap-2 mb-3">
              {/* eslint-disable-next-line no-nested-ternary */}
              {pendingFetch ? (
                Array.from({ length: 5 }, (v, k) => k)
                  // eslint-disable-next-line react/no-array-index-key
                  .map((_, idx) => <JobCardSkeleton key={idx} qty={6} />)
              ) : jobsData?.length === 0 || !Array.isArray(jobsData) ? (
                <h6>{t('dashboard.jobs.appliedlist.nojobs')}</h6>
              ) : (
                jobsData.map((item) => (
                  <Menu
                    options={savedJobOptions(t, item)}
                    key={item?.JobId}
                    onMenuSelect={(action) => handleJobOptions(action, item?.JobId)}
                    isArrowIcon={false}
                    classes="d-flex flex-column"
                  >
                    <AppliedJobCard
                      key={item.JobId}
                      job={item.Job}
                      jobId={item.JobId}
                      cretedDate={item.CreatedDate}
                      status={item.Status}
                      menuHandler={() => setShowThreeDotMenu(item.JobId)}
                      dots
                    />
                  </Menu>
                ))
              )}
            </div>
          )}
          <div className={classes.pagination}>
            {Array.isArray(jobsData) && (
              <PaginationPanel total={pagination?.TotalPages} active={currentPage} setActive={setCurrentPage} />
            )}
          </div>
          <div className={`row pt-5 ${classes.recommended}`}>
            <div className="col-12">
              <h5>{t('profile.tabs.recommendedjobs')}</h5>
              {pendingFetch ? (
                <div className={classes.skeletonContainer}>
                  {Array.from({ length: 3 }, (v, k) => k).map((_, idx) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <JobCardSkeleton key={idx} />
                  ))}
                </div>
              ) : (
                <RecommendedJobsList jobsData={recommendedJobs} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SavedJobs;
